import { ApiClient } from "../config/axiosConfig";
import { IPaginatedResponse } from "../models/Pagination";
import { IUserFilter } from "../models/UserFilter";
import {
  IChangePassword,
  ICreateUser,
  IUpdateUser,
  IUserPermission,
  IUserSystem,
} from "../models/Users";

export const userService = {
  getUsersWithFilters: async (
    params: IUserFilter
  ): Promise<IPaginatedResponse<IUserSystem>> => {
    const res = await ApiClient.GET<IPaginatedResponse<IUserSystem>>(
      "/users",
      params
    );
    return res;
  },
  createUser: async (data: ICreateUser): Promise<IUserSystem> => {
    const res = await ApiClient.POST<IUserSystem>("/users", data);
    return res;
  },
  updateUser: async (id: string, data: IUpdateUser): Promise<IUserSystem> => {
    const res = await ApiClient.PUT<IUserSystem>(`/users/${id}`, data);
    return res;
  },
  authorizeUser: async (
    id: string,
    permissions: number[]
  ): Promise<IUserPermission> => {
    const res = await ApiClient.PUT<IUserPermission>(
      `/users/${id}/permission`,
      {
        permissions,
      }
    );
    return res;
  },
  getPermissionsByUser: async (id: string): Promise<IUserPermission> => {
    const res = await ApiClient.GET<IUserPermission>(`/users/${id}/permission`);
    return res;
  },
  changePassword: async (id: string, password: string): Promise<boolean> => {
    const res = await ApiClient.PUT<boolean>(`/users/${id}/change-password`, {
      password,
    });
    return res;
  },
  changePasswordByUser: async (data: IChangePassword): Promise<boolean> => {
    const res = await ApiClient.POST<boolean>(`/users/change-password`, data);
    return res;
  },
  uploadAvatar: async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await ApiClient.POST<string>("/users/upload-avatar", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  },
};
